import { FeatureSettingsActionType } from "./constants";

export const getDefaultState = () => ({
  features: {
    colarado_river_water_access: false,
    central_arizona_colorado_river_water_access_per_person_municipal_areas: false,
    central_arizona_water_deliveries_and_uses: false,
    colorado_river_access_by_water_priority_level: false,
    central_arizona_colorado_river_water_use_vs_access: false,
  },
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case FeatureSettingsActionType.SET_FEATURE_SETTINGS:
      return setFeatureSettings(state, action);
    default:
      return state;
  }
};
function setFeatureSettings(state, { data }) {
  return {
    ...state,
    features: data,
  };
}
